/* eslint-disable react-hooks/exhaustive-deps */
import { Table, Button, Space, Select } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";

import CreateEditProblemModal from "./CreateEditProblemModal";
import DiscussionMessagesModal from "./DiscussionMessagesModal";
import ManageCodesModal from "./ManageCodesModal";
import ManageHintsModal from "./ManageHintsModal";
import VideoSectionUploadModal from "./VideoSectionUploadModal";
import { showErrorNotification, showSuccessNotification } from "../../../utils/notification";
import { clamp } from "../../../utils/responsiveHelpers";
import ConfirmationModal from "../../common-utils/ConfirmationModal";
import { RATING_OPTIONS } from "../helper";

const CPSheetProblemsManagementDash = ({ adminConfig, ROOT_URL }) => {
  const [isCreateEditProblemModalOpen, setIsCreateEditProblemModalOpen] = useState(false);
  const [currentProblemId, setCurrentProblemId] = useState();
  const [isDiscussionMessageModerationModalOpen, setIsDiscussionMessageModerationModalOpen] =
    useState(false);
  const [isVideoSectionUploadModalOpen, setIsVideoSectionUploadModalOpen] = useState(false);
  const [problemsList, setProblemsList] = useState([]);
  const [initialValues, setInitialValues] = useState({});
  const [filter, setFilter] = useState({});
  const [isUserConfirmationAction, setIsUserConfirmationAction] = useState(false);
  const [isManageCodesModalOpen, setIsManageCodesModalOpen] = useState(false);
  const [isManageHintsModalOpen, setIsManageHintsModalOpen] = useState(false);
  const [currentProblemRow, setCurrentProblemRow] = useState();

  const ratingOptions = RATING_OPTIONS.map((rating) => {
    return {
      label: rating,
      value: rating
    };
  });

  const fetchProblemsList = () => {
    axios
      .get(`${ROOT_URL}/admin/cp-sheet/problems/list`, {
        params: {
          filter: filter || {}
        }
      })
      .then((res) => {
        const { problems } = res.data;
        setProblemsList(problems);
        showSuccessNotification("Problems fetched successfully!");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleCreateEditProblem = (problemDetails) => {
    if (initialValues?.key !== undefined) {
      axios
        .post(`${ROOT_URL}/admin/cp-sheet/problems/update`, {
          problemParams: problemDetails,
          problemId: initialValues.key
        })
        .then(() => {
          setIsCreateEditProblemModalOpen(false);
          showSuccessNotification("Problem Updated Successfully");
          fetchProblemsList();
        })
        .catch((err) => {
          showErrorNotification(err);
        });
    } else {
      axios
        .post(`${ROOT_URL}/admin/cp-sheet/problems/create`, {
          problemParams: problemDetails
        })
        .then(() => {
          setIsCreateEditProblemModalOpen(false);
          showSuccessNotification("Problem Created Successfully");
          fetchProblemsList();
        })
        .catch((err) => {
          showErrorNotification(err);
        });
    }
  };

  const handleDeleteProblem = (problemId) => {
    axios
      .delete(`${ROOT_URL}/admin/cp-sheet/problems/delete`, {
        data: {
          problemId
        }
      })
      .then(() => {
        showSuccessNotification("User Deleted Successfully");
        fetchProblemsList();
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const columns = [
    {
      title: "S. No",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name"
    },
    {
      title: "Link",
      dataIndex: "link",
      key: "link"
    },
    {
      title: "Rating",
      dataIndex: "rating",
      key: "rating"
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      key: "createdBy"
    },
    {
      title: "Actions",
      key: "action",
      render: (row) => (
        <div
          id="cp_sheet_problem_row_actions"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around"
          }}
        >
          <Space wrap>
            <>
              <Button
                type="primary"
                onClick={() => {
                  setInitialValues(row);
                  setIsCreateEditProblemModalOpen(true);
                }}
              >
                Edit
              </Button>
              <Button
                type="primary"
                danger
                onClick={() => {
                  setIsUserConfirmationAction(true);
                  setCurrentProblemId(row.key);
                }}
              >
                Delete
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  setCurrentProblemId(row.key);
                  setIsDiscussionMessageModerationModalOpen(true);
                }}
              >
                View Messages
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  setIsManageHintsModalOpen(true);
                  setCurrentProblemRow(row);
                }}
              >
                Manage Hints
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  setCurrentProblemRow(row);
                  setIsManageCodesModalOpen(true);
                }}
              >
                Manage Codes
              </Button>
            </>
          </Space>
        </div>
      )
    }
  ];

  useEffect(() => {
    fetchProblemsList();
  }, [filter]);

  return (
    <div
      style={{
        marginTop: "20px",
        marginLeft: clamp(12, 30),
        marginRight: clamp(12, 30)
      }}
    >
      <div
        style={{
          marginBottom: "10px",
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          flexWrap: "wrap"
        }}
      >
        <Button
          type="primary"
          onClick={() => {
            setInitialValues({});
            setIsCreateEditProblemModalOpen(true);
          }}
        >
          Create Problem
        </Button>
        {adminConfig?.hasPromotionVideoUploadAccess && (
          <div
            style={{
              marginBottom: "10px"
            }}
          >
            <Button
              type="primary"
              onClick={() => {
                setIsVideoSectionUploadModalOpen(true);
              }}
            >
              Manage Promotion Videos
            </Button>
          </div>
        )}
      </div>
      <Select
        placeholder="Select Rating"
        style={{ width: "min(200px, 100%)", marginBottom: 10 }}
        onChange={(value) => {
          setFilter((prevFilter) => ({
            ...prevFilter,
            rating: value
          }));
        }}
      >
        {(ratingOptions || []).map((ratingOption) => (
          <Select.Option value={ratingOption.label} key={ratingOption.key}>
            {ratingOption.label}
          </Select.Option>
        ))}
      </Select>
      <Table
        columns={columns}
        dataSource={problemsList}
        bordered
        pagination={false}
        scroll={{ x: "max-content" }}
      />
      {isCreateEditProblemModalOpen === true && (
        <CreateEditProblemModal
          isModalOpen={isCreateEditProblemModalOpen}
          setIsModalOpen={setIsCreateEditProblemModalOpen}
          isEdit={initialValues?.key !== undefined}
          ratingOptions={ratingOptions}
          initialValues={initialValues || {}}
          handleCreateEditProblem={handleCreateEditProblem}
        />
      )}
      {isDiscussionMessageModerationModalOpen && (
        <DiscussionMessagesModal
          problemId={currentProblemId}
          ROOT_URL={ROOT_URL}
          isModalOpen={isDiscussionMessageModerationModalOpen}
          setIsModalOpen={setIsDiscussionMessageModerationModalOpen}
        />
      )}
      {isVideoSectionUploadModalOpen && (
        <VideoSectionUploadModal
          isModalOpen={isVideoSectionUploadModalOpen}
          setIsModalOpen={setIsVideoSectionUploadModalOpen}
          ROOT_URL={ROOT_URL}
        />
      )}
      {isUserConfirmationAction && (
        <ConfirmationModal
          isModalOpen={isUserConfirmationAction}
          setIsModalOpen={setIsUserConfirmationAction}
          description={"Are you sure you want to delete this problem from the CP31 sheet?"}
          confirmationAction={() => handleDeleteProblem(currentProblemId)}
        />
      )}
      {isManageHintsModalOpen && (
        <ManageHintsModal
          isModalOpen={isManageHintsModalOpen}
          setIsModalOpen={setIsManageHintsModalOpen}
          ROOT_URL={ROOT_URL}
          currentProblemRow={currentProblemRow}
          setProblemsList={setProblemsList}
        />
      )}
      {isManageCodesModalOpen && (
        <ManageCodesModal
          isModalOpen={isManageCodesModalOpen}
          setIsModalOpen={setIsManageCodesModalOpen}
          ROOT_URL={ROOT_URL}
          currentProblemRow={currentProblemRow}
          setProblemsList={setProblemsList}
        />
      )}
    </div>
  );
};

export default CPSheetProblemsManagementDash;
